import { render } from "./leave_admin.vue?vue&type=template&id=3ac281a6"
import script from "./leave_admin.vue?vue&type=script&lang=js"
export * from "./leave_admin.vue?vue&type=script&lang=js"

import "./leave_admin.vue?vue&type=style&index=0&id=3ac281a6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__